export default '/account/reading/@id'
